import classNames from 'classnames';

import { useEffect, useState } from 'react';

function PaceInputReadonly({ value, className }: { value: number; className?: string }) {
  const [inputValue, setInputValue] = useState({
    minutes: 0,
    seconds: 0
  });

  const valueToTime = (v: number) => {
    const minutes = Math.floor((v % 3600) / 60);
    const seconds = v % 60;
    return {
      minutes,
      seconds
    };
  };

  const formatSeconds = (s: number) => {
    return s < 10 ? `0${s}` : s;
  };

  useEffect(() => {
    setInputValue(valueToTime(value));
  }, [value]);

  return (
    <div
      className={classNames(
        'py-xs',
        'w-fit',
        'flex flex-row items-center justify-start',
        className
      )}
    >
      <div>{inputValue.minutes}</div>
      <div>:</div>
      <div>{formatSeconds(inputValue.seconds)}</div>
    </div>
  );
}

export default PaceInputReadonly;
